export const tabs = [
  {
    id: 1,
    label: 'Detail',
    intlKey: 'tabs.detail',
    path: '/detail',
    type: 'tab'
  },
  {
    id: 2,
    label: 'Registration',
    intlKey: 'tabs.registration',
    path: '/registration',
    type: 'tab'
  },
  {
    id: 3,
    label: 'Payment',
    intlKey: 'tabs.payment',
    path: '/payment',
    type: 'tab'
  },
  {
    id: 4,
    label: 'Awards',
    intlKey: 'tabs.awards',
    path: '/awards',
    type: 'tab'
  },
  {
    id: 5,
    label: 'Award Units',
    intlKey: 'tabs.award_units',
    path: '/award-units',
    type: 'tab'
  },
  {
    id: 6,
    label: 'Award Leaders',
    intlKey: 'tabs.award_leaders',
    path: '/award-leaders',
    type: 'tab'
  },
  {
    id: 7,
    label: 'Participants',
    intlKey: 'tabs.participants',
    path: '/participants',
    type: 'tab'
  }
]

export const tableHeaders = [
  {
    id: 1,
    label: 'ID',
    intlKey: 'table.id',
    sortableId: 'id'
  },
  {
    id: 3,
    label: 'Name',
    intlKey: 'table.name',
    sortableId: 'name'
  },
  {
    id: 4,
    label: 'Country',
    intlKey: 'table.country',
    sortableId: 'country.name'
  }
  // {
  //   id: 4,
  //   label: 'Registration',
  //   intlKey: 'table.registration'
  // },
  // {
  //   id: 11,
  //   label: 'Payments',
  //   intlKey: 'table.payments'
  // },
  // {
  //   id: 10,
  //   label: 'Awards',
  //   intlKey: 'table.awards'
  // },
  // {
  //   id: 5,
  //   label: 'AUs',
  //   intlKey: 'table.aus'
  // },
  // {
  //   id: 6,
  //   label: 'Leaders',
  //   intlKey: 'table.leaders'
  // },
  // {
  //   id: 7,
  //   label: 'Participants',
  //   intlKey: 'table.participants'
  // }
]
